import { render, staticRenderFns } from "./RecipeItemStepEdit.vue?vue&type=template&id=25025f22&scoped=true&"
import script from "./RecipeItemStepEdit.vue?vue&type=script&lang=js&"
export * from "./RecipeItemStepEdit.vue?vue&type=script&lang=js&"
import style0 from "./RecipeItemStepEdit.vue?vue&type=style&index=0&id=25025f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25025f22",
  null
  
)

export default component.exports